import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { ClientGpDto } from 'src/api/FiretrolApiClient';
import { useOrganization } from 'src/hooks/useOrganization';
import { Header } from 'src/design/organisms/Header';
import {
  useTable,
  useTableState,
} from 'src/design/organisms/DataTable/useTable';
import { useTableExports } from 'src/design/organisms/useTableExports';

const getColumns = (): MRT_ColumnDef<ClientGpDto>[] => {
  return [
    {
      accessorKey: 'custNumber',
      header: 'Number',
      size: 200,
    },
    {
      accessorKey: 'custName',
      header: 'Name',
    },
  ];
};

export const Customers: React.FC = () => {
  const { clients, clientsLoading } = useOrganization();
  const columns = useMemo(() => getColumns(), []);

  const tableState = useTableState({
    identifier: 'customers',
    columns: columns,
    defaultSorting: [{ id: 'custNumber', desc: false }],
  });

  const tableExports = useTableExports<ClientGpDto>('customers', (data) => {
    return data.map((item) => ({
      ['Number']: item.custNumber,
      ['Name']: item.custName,
    }));
  });

  const { table } = useTable({
    ...tableState,
    tableOptions: {
      enableRowActions: false,
      enableClickToCopy: false,
      columns: columns,
      data: clients,
      manualPagination: false,
      manualSorting: false,
      manualFiltering: false,
    },
    getRowId: (row) => String(row.custNumber),
    totalCount: clients.length,
    isLoading: clientsLoading,
    isFetching: false,
    isError: false,
    ...tableExports,
  });

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [{ text: 'Settings' }, { text: 'Customers' }],
        }}
        title="Customers"
        helpText="View and manage your organization's customers"
      />
      {table}
    </>
  );
};
